import { render, staticRenderFns } from "./PortalAuthenticate.vue?vue&type=template&id=07a46145&scoped=true&"
import script from "./PortalAuthenticate.vue?vue&type=script&lang=js&"
export * from "./PortalAuthenticate.vue?vue&type=script&lang=js&"
import style0 from "./PortalAuthenticate.vue?vue&type=style&index=0&id=07a46145&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a46145",
  null
  
)

export default component.exports